import React from 'react'
import DiamondTransfersContainer from 'containers/panel/reseller/diamond-transfers-container'

const DiamondTransfersPage = () => {
  return (
    <DiamondTransfersContainer/>
  )
}

export default DiamondTransfersPage